import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { showActionWindowOfSelectedItem } from 'src/action-window/business-logic/action-window-actions';
import { AppState } from 'src/common/redux/configure-store';
import { MiddleAreaActions } from 'src/common/redux/reducers/middle-area-reducer';
import MiddleArea from '../tabs';

type Props = typeof mapDispatchToProps & IMiddleAreaWrapperState;

const MiddleAreaWrapper: React.FC<Props> = (props): JSX.Element => {
  useEffect(() => {
    showActionWindowOfSelectedItem();
  }, []);

  return <MiddleArea {...props} />;
};

interface IMiddleAreaWrapperState {
  tabValue: number;
  trainingModeActive: boolean;
  activeTransaction: boolean;
}

const mapStateToProps = (state: AppState): IMiddleAreaWrapperState => ({
  tabValue: state.middleArea.tabValue,
  trainingModeActive: state.posMode.trainingMode,
  activeTransaction: !!state.transaction.transactionIdExists,
});

const mapDispatchToProps = {
  setMiddleAreaState: MiddleAreaActions.setMiddleAreaState,
};

export default connect(mapStateToProps, mapDispatchToProps)(MiddleAreaWrapper);
